import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { FooterIngram } from './internal/FooterIngram';
import { jsx as _jsx } from "react/jsx-runtime";
export function Footer(props) {
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "footer",
    "data-component": "Footer",
    "data-source-file": "Footer.tsx",
    children: /*#__PURE__*/_jsx(FooterIngram, _extends({}, props, {
      "data-element": "FooterIngram",
      "data-source-file": "Footer.tsx"
    }))
  });
}